import axios from 'axios'
import {apiDomain} from '@/config'

console.log('设置')
axios.defaults.headers['Content-Type'] = 'application/json'

const instance = axios.create({
    baseURL: apiDomain
})

export default instance



// WEBPACK FOOTER //
// ./src/util/http.js